<template>
  <o-view>
    <o-nav-bar title="Passes" :has-back-button="true" />
    <o-section :is-transparent="true">
      <o-ticket-summary
        date="25/02"
        icon="brands/nmbs"
        label="Rail Pass"
        description="2nd class - exp. 25/02/2019"
        price="6 left"
      />
      <o-ticket-summary
        date="20/01"
        icon="brands/delijn"
        label="M-ticket 10"
        description="exp. 20/01/2019"
        price="4 left"
      />
    </o-section>
  </o-view>
</template>

<script>
import OPayButton from '@/components/OPayButton.vue'
import OTicketSummary from '@/components/OTicketSummary.vue'
export default {
  components: {
    OPayButton,
    OTicketSummary
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    }
  }
}
</script>
